import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceOrderById } from '@/api/financial-center'
import * as math from 'mathjs'

@Component({})
export default class OrderInfo extends Vue {
    orderId: number = undefined
    logShow = true
    infoData: any = {}
    status = ''
    orderType = ''
    isUpdatedData = ''
    isShow = ''
    activities = []

    get thisRatioPrice() {
        let num = math.divide(math.bignumber(this.infoData.priceOrRatio), 100)
        return math.number(math.multiply(math.bignumber(this.infoData.price), num))
    }

    created() {
        this.orderId = Number(this.$route.query.id)
        this.status = this.$route.query.status as string
        this.isShow = this.$route.query.isShow as string
        this.orderType = this.$route.query.orderType as string || ''
        this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
        this.getInfoData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    async getInfoData() {
        const data: any =  await getFinanceOrderById({ id: this.orderId, isUpdatedData: this.isUpdatedData })
        this.infoData = data.financeOrder
        //    审批流程
        this.activities = data.financeOrder.messageReviewList
    }

    clickEditButton() {
        if(this.status === '审批中') {
            this.$message.error('审批中的项目不可编辑')
            return
        }
        this.$router.push({
            path: 'newOrdinaryOrder',
            query: {
                orderId: String(this.orderId),
                isUpdatedData: this.isUpdatedData
            }
        })
    }
}
